module.exports = __webpack_public_path__ + "static/Bulkitems-3297b1e6d47f1a55ff28821f20e30e7f.svg";